module.exports = ".bouton-photo{\n  margin: 0;\n  opacity: 0.6;\n}\n\n.label-style{\n  width: 100vh;\n  display: inline-block;\n  margin: 0px;\n}\n\n.input-dont-show{\n  position: fixed;\n  top: -100em;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/photo/photo.component.css
// module id = ./src/app/photo/photo.component.css
// module chunks = main